function getBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = error => reject(error)
    reader.readAsDataURL(file)
  })
}

function scaleImage(
  fileData: string,
  maxDimension: number
): Promise<HTMLCanvasElement> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.addEventListener('load', () => {
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      if (!context) return reject(new Error('Unable to get canvas context'))

      if (img.width > img.height) {
        canvas.width = maxDimension
        canvas.height = canvas.width * (img.height / img.width)
      }
      else {
        canvas.height = maxDimension
        canvas.width = canvas.height * (img.width / img.height)
      }

      context.drawImage(img, 0, 0, canvas.width, canvas.height)
      resolve(canvas)
    })
    img.src = fileData
  })
}

function compressImage(
  canvas: HTMLCanvasElement,
  quality: number,
  limit: number
): string {
  const attachment = canvas.toDataURL('image/jpeg', quality)
  if (attachment.length <= limit) return attachment
  return compressImage(canvas, quality - 0.1, limit)
}

export default async function scaleCompressImage(
  file: File,
  {
    maxSize = 80 * 1024,
    maxDimension = 800,
    quality = 0.92,
  }: {
    maxSize?: number,
    maxDimension?: number,
    quality?: number
  } = {}
): Promise<string> {
  const base64String = await getBase64(file)
  const canvas = await scaleImage(base64String, maxDimension)
  return compressImage(canvas, quality, maxSize)
}
